import { Bid } from "./bid";
import { AuctionBidDTO } from "../DTO/auctionBidDTO";

export class AuctionBid extends Bid{
    
    public partialUserName!:string;
    public rank?:number;
    public requestorBid:boolean = false;

    constructor(){
        super();
    }

    get currentDisplayBid(){
        return Math.ceil(this.currentBid);
    }

    get displayRank(){
        if(this.rank==1) return "Highest Bidder";
        if(this.rank==2) return "2nd";
        if(this.rank==3) return "3rd";
        return undefined;
    }

    public static mapToDTO(param:AuctionBid) : AuctionBidDTO{
        
        let dto = new AuctionBidDTO();
        try
        {
            dto.id = param.id;
            dto.auctionId = param.auctionId;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.currentBid = param.currentBid;
            dto.bidDateTime = param.bidDateTime.toISOString();
            dto.autoBid = param.autoBid;
            dto.bidAccepted = param.bidAccepted;
            dto.askAmount = param.askAmount;
            dto.askAmountExclusivitySeconds = param.askAmountExclusivitySeconds;
            dto.askAccepted = param.askAccepted;
            dto.isBackup = param.isBackup;
            dto.partialUserName = param.partialUserName;
            dto.rank = param.rank;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionBidDTO, userId:string|undefined) : AuctionBid
    {
        
        let obj = new AuctionBid();
        try
        {
            obj.id = param.id;
            obj.auctionId = param.auctionId;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.currentBid = param.currentBid;
            obj.bidDateTime = new Date(param.bidDateTime);
            obj.autoBid = param.autoBid;
            obj.bidAccepted = param.bidAccepted;
            obj.askAmount = param.askAmount;
            obj.askAmountExclusivitySeconds = param.askAmountExclusivitySeconds;
            obj.askAccepted = param.askAccepted;
            obj.isBackup = param.isBackup;
            obj.partialUserName = param.partialUserName;
            obj.rank = param.rank;
            obj.requestorBid = !!userId && param.requestorId==userId; //userId: own bidder key for public bids (see Auction.ownBidderKey)
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}